// Front-end only: outcome of validating one currency entry; each non-valid value has its own field issue.

export const CurrencyVerdict = {
  VALID: 'valid',
  EMPTY: 'empty',
  INVALID_CHARACTERS: 'invalidCharacters',
  INVALID_AMOUNT: 'invalidAmount'
} as const satisfies Record<string, string>

export type CurrencyVerdict = (typeof CurrencyVerdict)[keyof typeof CurrencyVerdict]
